import lottie from 'lottie-web';
import { loadFonts } from '@loaders/FontLoader';

export default class LoadScene extends Phaser.Scene {
  constructor() {
    super({ key: 'LoadScene' });
  }

  async preload() {
    this.load.json('loading-anim', 'assets/loadAnims/cuemath_loading.json');
    await loadFonts();
  }

  create() {
    this.loadingAnim = this.addLoaderLottie(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
    );

    this.assetsLoad();
    this.load.start();

    this.load.on(
      'progress',
      () => {
        this.loadingAnim.anim.playSegments([0, 25], true);
      },
      this,
    );

    this.load.on(
      'complete',
      () => {
        this.loadingAnim.anim.loop = false;
        this.loadingAnim.anim.playSegments([26, 41], true);
        this.loadingAnim.anim.addEventListener('complete', () => {
          this.scene.start('StartScene');
        });
      },
      this,
    );
  }

  addLoaderLottie(_x, _y) {
    const lottieRef = this.add
      .dom(_x - this.cameras.main.width / 2, _y - this.cameras.main.height / 2, 'div')
      .setScale(0.7);

    const lottieDiv = lottieRef.node;
    lottieDiv.style.height = '100%';
    lottieDiv.style.width = '100%';

    const lottieAnim = lottie.loadAnimation({
      container: lottieDiv,
      renderer: 'svg',
      loop: true,
      autoplay: false,
      animationData: this.cache.json.get('loading-anim'),
    });

    return { anim: lottieAnim, dom: lottieRef };
  }

  assetsLoad() {
    this.load.plugin('rexsoundfadeplugin', 'assets/rexsoundfadeplugin.min.js');

    this.load.audio('bgaudio', 'assets/audio/BG Music.mp3');
    this.load.audio('heliaudio', 'assets/audio/Helicopter.wav');
    this.load.audio('hintaudio', 'assets/audio/Hint Alert.mp3');
    this.load.audio('incorrectdropaudio', 'assets/audio/wrongdrop.mp3');
    this.load.audio('correctdropaudio', 'assets/audio/Success_Drop.mp3');
    this.load.audio('yayaudio', 'assets/audio/Yay.wav');

    for (let i = 1; i <= 10; i++) {
      this.load.audio('qa' + i, 'assets/audio/qa' + i + '.mp3');
    }

    for (let i = 1; i <= 4; i++) {
      this.load.audio('ta' + i, 'assets/audio/ta' + i + '.mp3');
    }

    this.load.image('playButton', 'assets/StartSceneAssets/Button CTA.png');
    this.load.image('startSceneBG', 'assets/StartSceneAssets/Start Screen_New.png');
    this.load.image('gameName', 'assets/StartSceneAssets/Game Name.png');
    this.load.image('helicopterStatic', 'assets/StartSceneAssets/Helicopter.png');
    this.load.atlas('heliAnim', 'assets/StartSceneAssets/heliAnim.png', 'assets/StartSceneAssets/heliAnim.json');
    this.load.image('playHover', 'assets/StartSceneAssets/playHover.png');

    this.load.image('tutorialSceneBG', 'assets/TutorialSceneAssets/tutorialSceneBG.png');
    this.load.image('overlay', 'assets/TutorialSceneAssets/Overlay.png');
    this.load.image('speechBubble', 'assets/TutorialSceneAssets/Speech Bubble.png');
    this.load.spritesheet('numberLine', 'assets/TutorialSceneAssets/numberLine.png', {
      frameWidth: 1391,
      frameHeight: 70,
    });
    this.load.multiatlas(
      'heliHoverAnim',
      'assets/TutorialSceneAssets/heliHover/heliHoverAnim.json',
      'assets/TutorialSceneAssets/heliHover',
    );
    this.load.image('qBoard', 'assets/TutorialSceneAssets/Q Board.png');
    this.load.image('tutSceneText1', 'assets/TutorialSceneAssets/textnew2.png');
    this.load.image('sliderButton', 'assets/TutorialSceneAssets/SliderButton.png');
    this.load.image('sliderBar', 'assets/TutorialSceneAssets/sliderbar.png');
    this.load.image('handIcon', 'assets/TutorialSceneAssets/handIcon.png');
    this.load.spritesheet('linePoint', 'assets/TutorialSceneAssets/numLinePoints.png', {
      frameWidth: 18,
      frameHeight: 15,
    });
    this.load.atlas(
      'checkButtonAnim',
      'assets/TutorialSceneAssets/checkButtonAnim.png',
      'assets/TutorialSceneAssets/checkButtonAnim.json',
    );
    this.load.atlas(
      'checkRightAnim',
      'assets/TutorialSceneAssets/checkRightAnim.png',
      'assets/TutorialSceneAssets/checkRightAnim.json',
    );
    this.load.atlas(
      'checkWrongAnim',
      'assets/GameSceneAssets/buttonWrongAnim.png',
      'assets/GameSceneAssets/buttonWrongAnim.json',
    );
    this.load.atlas(
      'checkConfettiAnim',
      'assets/TutorialSceneAssets/checkConfettiAnim.png',
      'assets/TutorialSceneAssets/checkConfettiAnim.json',
    );
    this.load.image('redPoint', 'assets/TutorialSceneAssets/red point.png');
    this.load.atlas(
      'dropButtonAnim',
      'assets/TutorialSceneAssets/dropButtonAnim.png',
      'assets/TutorialSceneAssets/dropButtonAnim.json',
    );
    this.load.multiatlas(
      'heliDropAnim',
      'assets/TutorialSceneAssets/bearDrop/bearDropAnim.json',
      'assets/TutorialSceneAssets/bearDrop',
    );
    this.load.multiatlas(
      'bearWrongAnim',
      'assets/GameSceneAssets/bearWrongAnim/bearWrongAnim.json',
      'assets/GameSceneAssets/bearWrongAnim',
    );
    this.load.image('tutSceneText4', 'assets/TutorialSceneAssets/textnew.png');
    this.load.image('tutSceneText5', 'assets/TutorialSceneAssets/droppandatext.png');
    this.load.image('numberSet0', 'assets/TutorialSceneAssets/numberSet0.png');
    this.load.image('numberBlackSet0', 'assets/TutorialSceneAssets/numberBlackSet0.png');
    this.load.image('leftJoystick', 'assets/TutorialSceneAssets/leftJoystick.png');
    this.load.image('rightJoystick', 'assets/TutorialSceneAssets/rightJoystick.png');

    this.load.image('hintIcon', 'assets/TutorialSceneAssets/Hint.png');
    this.load.image('hint_1', 'assets/TutorialSceneAssets/hint-1hdpi.png');
    this.load.image('hint_2', 'assets/TutorialSceneAssets/hint-2hdpi.png');
    this.load.image('closeHint', 'assets/TutorialSceneAssets/closeHintIconhdpi.png');
    this.load.atlas(
      'hintFinalAnim',
      'assets/TutorialSceneAssets/hintFinalAnim.png',
      'assets/TutorialSceneAssets/hintFinalAnim.json',
    );

    this.load.multiatlas(
      'spotlight',
      'assets/EndSceneAssets/spotlight/spotlightAnimNew.json',
      'assets/EndSceneAssets/spotlight',
    );
    this.load.image('endScreenOverlay', 'assets/EndSceneAssets/endscreenoverlay.png');
    this.load.image('gameOver', 'assets/EndSceneAssets/Game Over.png');
    this.load.image('correctIcon', 'assets/EndSceneAssets/correctIcon.png');
    this.load.image('incorrectIcon', 'assets/EndSceneAssets/incorrectIcon.png');
    this.load.image('retryButton', 'assets/EndSceneAssets/Retry Button.png');
    this.load.image('nextButton', 'assets/EndSceneAssets/next button.png');

    this.load.image('dropDown', 'assets/TutorialSceneAssets/dropcheckbuttons/dropDown.png');
    this.load.image('dropUp', 'assets/TutorialSceneAssets/dropcheckbuttons/dropUp.png');
    this.load.image('rightDown', 'assets/TutorialSceneAssets/dropcheckbuttons/rightDown.png');
    this.load.image('rightUp', 'assets/TutorialSceneAssets/dropcheckbuttons/rightUp.png');
    this.load.image('leftDown', 'assets/TutorialSceneAssets/dropcheckbuttons/leftDown.png');
    this.load.image('leftUp', 'assets/TutorialSceneAssets/dropcheckbuttons/leftUp.png');
  }

  update() {}
}
